module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"developer-dave","short_name":"dev-dave","start_url":"/","background_color":"#18171c","theme_color":"#18171c","display":"minimal-ui","icon":"src/images/favicon-32-min.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"89fed5b4b9c1f0bccdd77eb25e1bc2d4"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
